// extracted by mini-css-extract-plugin
export default {"item":"MultiLineCellDoubleStub_item__A62bl","placeHolderShimmer":"MultiLineCellDoubleStub_placeHolderShimmer__+9gva"};